import {cloneElement, isValidElement} from 'react'
import {useMergeRefs} from '@floating-ui/react'
import {EitjeButton} from '../../eitje_button'
import {DropdownItemLayout} from '../../dropdown/components/dropdown_item_layout'
import {useFloatingContext} from '../context'

export const FloatingReferenceTrigger = ({ref, trigger, showRightArrowIfNested, ...rest}) => {
	const {refs, isOpen, getReferenceProps, isNested} = useFloatingContext()
	const mergedRef = useMergeRefs([refs.setReference, ref, trigger?.ref])

	const {onClick, ...triggerProps} = trigger?.props || {}
	const referenceProps = {
		...getReferenceProps({ref: mergedRef, onClick, ...rest}),
		isOpen,
		...triggerProps,
	}

	if (isValidElement(trigger)) {
		return cloneElement(trigger, {
			ref: mergedRef,
			...referenceProps,
		})
	}

	// render a DropdownItem in case the trigger itself is a dropdown item
	if (isNested) {
		return (
			<DropdownItemLayout
				background={isOpen && 'light-blue'}
				{...referenceProps}
				iconRight={showRightArrowIfNested && 'chevron-small-right'}
				{...trigger}
				ref={mergedRef}
			/>
		)
	}

	// otherwise render default EitjeButton trigger
	return <EitjeButton {...referenceProps} {...trigger} ref={mergedRef} />
}
